(function($) {
	'use strict';

	/**
	 * Extract CRF mapping for a specific control UID prefix
	 * 
	 * This function searches through the Combined data structure to find
	 * all related control items that match the given control UID prefix
	 * and extracts their CRF mappings.
	 * 
	 * @param {Object} data - The data object containing Combined structure
	 * @param {string} controlUidPrefix - The control UID prefix to search for
	 * @returns {Array} Array of CRF mapping strings
	 */
	function extractCRFMapping(data, controlUidPrefix) {
		// Validating structure as previously explained
		if (!data.Combined) {
			// console.error("Data structure is not as expected.");
			return [];
		}

		// Escape parentheses in the controlUidPrefix for use in regex
		const escapedControlUidPrefix = controlUidPrefix.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
		const regex = new RegExp(`^${escapedControlUidPrefix}(\\D|$)`); // Match controlUidPrefix followed by a non-digit or end of string
		
		// Always use the flat array structure since we're using the current assessment's quality data
		if (!Array.isArray(data.Combined)) {
			// console.error("data.Combined is not an array - unexpected structure");
			return [];
		}
		
		const allRelatedCSItems = data.Combined.flatMap(item => item.relatedCSItems || []);

		return allRelatedCSItems.filter(item => item.controluid && regex.test(item.controluid.S))
			.flatMap(item => {
				const crfMapping = item.crfmapping.S;
				if (!crfMapping) return [];

				// Handle multi-line CRF mappings by splitting on newlines and trimming
				const mappings = crfMapping.split(/\s*\\n\s*|\s*\n\s*/).filter(id => id.trim());
				// console.log(`Parsed CRF mapping "${crfMapping}" into:`, mappings);
				return mappings;
			});
	}

	// Export for use in other modules
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = { extractCRFMapping };
	} else if (typeof window !== 'undefined') {
		window.extractCRFMapping = extractCRFMapping;
	}

})(jQuery);
